import { ItemsList } from "@/pages/tina/items";

/**
 * `/tina/hitl` — the curator HITL queue.
 *
 * `contentTypeScope="scrape"` keeps **enrichment** parks out: they have their
 * own surface (`/tina/enrichment`), Tina hides them from an un-opted-in
 * `GET /events` and `metric_hitl_backlog` excludes their reasons from the
 * dashboard count this page is meant to match. Without it the content-type
 * select could switch this page into the enrichment class — and persist the
 * switch to localStorage under `tina-items:hitl:content-type`, so the page came
 * back filtered in the next session while the title still read "HITL queue".
 *
 * **It keeps refresh parks out too, now on the same principle.** Ruling R34 had
 * them queue here — `list_events` widens a `status=hitl` read to the refresh
 * class, uniquely — but a refresh review is not a scrape event that stalled and
 * the owner has ruled it a surface of its own (`/tina/refresh-review`), a
 * sibling of the enrichment one. Tina cannot express the exclusion: `GET /events`
 * takes one exact `content_type` (or a class sentinel) and a single-value
 * `hitl_reason` with no negation, so `ItemsList` drops the rows on the page
 * instead — see `HIDE_REFRESH_ROWS`, which `listsHitlRows` turns on for exactly
 * the listing R34 widened.
 *
 * **The notice that used to reconcile that is gone, at the owner's request
 * (2026-09-07).** A banner reading "1,113 refresh reviews are waiting on their
 * own page — they are counted in the total below but not listed here" sat above
 * every visit to this queue, and the owner does not want it. The consequence is
 * deliberate and worth knowing: the footer `total` still counts the refresh
 * rows this page drops, so it is larger than the rows on screen and nothing on
 * the page says why. The count itself is unchanged — `/tina/home` still shows
 * "Refresh review — N waiting" next to the link that opens them.
 */
export const HitlList = () => (
  <ItemsList
    title="HITL queue"
    persistKey="hitl"
    contentTypeScope="scrape"
    enableOpenAllInTabs
    initialFilters={[{ field: "status", operator: "eq", value: "hitl" }]}
  />
);
